import { rem } from 'polished';
import styled, { css } from 'styled-components';
import { totalNavigationPxHeight } from '../../components/navigation/Navigation.styles';

export interface StyledDefaultLayoutTwoProps {
  bgColor: string;
  hideBottomPadding?: boolean;
  sectionVisible: string;
}

export const StyledDefaultLayoutTwo = styled.div<StyledDefaultLayoutTwoProps>`
  & > .content {
    padding: ${rem(totalNavigationPxHeight)} 0 2rem 0;
    background-color: ${({ bgColor }: { bgColor: string }) => bgColor};
    background-image: url(/assets/images/home/wb/bg_desktop.png);
    background-position: center top;
    background-size: 100% auto;
    background-repeat: no-repeat;
    min-height: calc(100vh - ${rem(totalNavigationPxHeight + 100)});

    @media (max-width: 768px) {
      background-image: url(/assets/images/home/bg_mobile.png);
    }

    ${({ hideBottomPadding }) =>
      hideBottomPadding &&
      css`
        padding-bottom: 0;
      `}
  }

  @media print {
    margin: 0;
  }
`;
